import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../shared/ui/button';
import { Field } from '../../../shared/ui/field';
import { Input } from '../../../shared/ui/input';
import { schema, type Values } from './model';

/** Names plus the read-only sign-in email. `error` is the failed save, shown next to the button. */
export function EditProfileForm({
  defaultValues,
  email,
  error,
  onSubmit,
}: {
  defaultValues: Values;
  email: string;
  error: string | null;
  onSubmit: (values: Values) => Promise<void>;
}) {
  const { t } = useTranslation(['account', 'auth']);
  const { register, handleSubmit, formState } = useForm<Values>({
    resolver: zodResolver(schema),
    defaultValues,
  });
  return (
    <form className="grid gap-4" onSubmit={handleSubmit(onSubmit)}>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label={t('auth:fields.firstName')} error={formState.errors.firstName?.message}>
          <Input id="account-first-name" autoComplete="given-name" {...register('firstName')} />
        </Field>
        <Field label={t('auth:fields.lastName')} error={formState.errors.lastName?.message}>
          <Input id="account-last-name" autoComplete="family-name" {...register('lastName')} />
        </Field>
      </div>
      <Field label={t('profile.email')} description={t('profile.emailHelp')}>
        <Input id="account-email" type="email" value={email} readOnly />
      </Field>
      {error ? (
        <p role="alert" className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
      <div>
        <Button type="submit" disabled={formState.isSubmitting}>
          {t('profile.save')}
        </Button>
      </div>
    </form>
  );
}
